import '../styles/ModalRelease.css';
import { useTranslation } from 'react-i18next';

function ModalInfo({showModal, setShowModal}) {
    const { t } = useTranslation();
    function onClose() {
        setShowModal(!showModal)
    }

	return (
		<div className="modal-overlay">
            <div className="modal">
                <div className='modal-rev'>
                    <h2>{t('modalInfo.title')}</h2>
                    {t('modalInfo.description1')}<br />
                    {t('modalInfo.description2')}<br />
                    {t('modalInfo.description3')}
                </div>

                <hr /> 

                <div className='modal-rev'>
                    <h2>{t('modalInfo.questions')}</h2>
                    {t('modalInfo.suggestion')} <br />
                    {t('modalInfo.email')} <a href='mailto:contact@zeldle.xyz'>contact@zeldle.xyz</a>.<br /><br />
                    
                    Zeldle 🔺
                </div>
                <img src='/images/assets/close.png' alt='close' className="close-button" onClick={onClose} />
            </div>
        </div>
	)
}

export default ModalInfo
